import { Geometry } from "geojson";
import { Mode } from "../../../components/general/types/Modify";
import { MAP_FEATURES_ENDPOINT } from "../../../libs/config";
import { RouteProps } from "../../../types";
import { AvoidanceZoneData } from "../../../types/documents";
import { ModifyContainer } from "../../general";
import {
  configInputs,
  configSubmit,
  constraints,
  initialData,
} from "./resources";

const putEndpoint = `${MAP_FEATURES_ENDPOINT}/avoidance-zone/submit`;
const queryEndpoint = `${MAP_FEATURES_ENDPOINT}/avoidance-zone`;

export interface Props extends RouteProps {
  mode: Mode;
  geometry: Geometry;
  properties: object | null;
  id: string;
  onSuccess: (id: string, data: AvoidanceZoneData) => void;
}
type Component = (props: Props) => JSX.Element;

export const AvoidanceZoneModify: Component = ({
  mode,
  geometry,
  properties,
  id,
  onSuccess,
  ...routeProps
}) => {
  return (
    <ModifyContainer<AvoidanceZoneData>
      {...routeProps}
      putEndpoint={putEndpoint}
      queryEndpoint={queryEndpoint}
      mode={mode}
      initialData={initialData(geometry, properties)}
      manualQueryId={id}
      componentConfiguration={[
        configInputs(mode, routeProps.jwt),
        configSubmit,
      ]}
      constraints={constraints}
      redirectPath={""}
      onSuccess={onSuccess}
      isDialog
    />
  );
};
